import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPaginatedResultMyOskLectureGroupVm } from '../paginated-result-my-osk-lecture-group-vm.model';
import { SortOrder } from '../sort-order.model';
@Injectable({ providedIn: 'root' })
export class MyOskLectureGroupsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureGroups`;
  }
  get(archived: boolean, search: string, sortColumn: string, page?: number, pageSize?: number, sortOrder?: SortOrder): Observable<IPaginatedResultMyOskLectureGroupVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (archived !== undefined && archived !== null) {
      params = params.set('archived', archived.toString());
    }
    if (search !== undefined && search !== null) {
      params = params.set('search', search.toString());
    }
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (sortColumn !== undefined && sortColumn !== null) {
      params = params.set('sortColumn', sortColumn.toString());
    }
    if (sortOrder !== undefined && sortOrder !== null) {
      // The API binds the enum from its plain name; the JSON-quoted form ends in 400 Bad Request.
      params = params.set('sortOrder', sortOrder);
    }
    return this.http.get<IPaginatedResultMyOskLectureGroupVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
